
import { defineComponent, inject } from 'vue';
import DsCookies from './DsCookies';

export default defineComponent({
  setup() {
    const cookies: DsCookies | undefined = inject('cookies');

    if (!cookies) {
      return;
    }

    return {
      cookies
    };
  }
});
